const getFormContainingField = require("../form/getFormContainingField");
const getPrivacyPolicyCheckboxFromForm = require("../form/getPrivacyPolicyCheckboxFromForm");
const showHidePrivacyPolicyCheckboxBasedOnCountry = require("../form/showHidePrivacyPolicyCheckboxBasedOnCountry");

/**
 * @param countrySelect {HTMLSelectElement}
 * @return {void}
 */
module.exports = function showHidePrivacyPolicyCheckboxBasedOnCountrySelect(countrySelect) {
    const form = getFormContainingField(countrySelect);

    if (form) {
        const privacyPolicyCheckbox = getPrivacyPolicyCheckboxFromForm(form);

        if (privacyPolicyCheckbox) {
            const country = countrySelect.value;
            showHidePrivacyPolicyCheckboxBasedOnCountry(privacyPolicyCheckbox, country);
        }
    }
}